import { CloseOutlined, DeleteFilled, DownOutlined, PlusOutlined, SearchOutlined, TagOutlined, UpOutlined } from '@ant-design/icons'
import { Alert, Button, Checkbox, Col, DatePicker, Form, FormProps, Input, InputNumber, Pagination, Radio, Row, Select, TimePicker, TreeSelect } from 'antd'
import React, { Dispatch, forwardRef, MutableRefObject, SetStateAction, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import * as selectOptionsApi from '../../../../../api/selectOptions/selectOptionsApi'

import { AgGridReact } from 'ag-grid-react'
import { ConfigProvider } from 'antd/lib'
import { useForm } from 'antd/lib/form/Form'
import viVN from 'antd/locale/vi_VN'
import dayjs from 'dayjs'
import { empty_image_cus, Mail, SMS, ZNS } from '../../../../../components/ExportImgFigma'
import { NodataTable } from '../../../../../components/NoDataTable'
import SvgIconWithMask from '../../../../../components/SvgIconWithMask'
import { URL_TEMPLATE_IMG } from '../../../../../env'
import useLoading from '../../../../../hook/useLoading'
import useToast from '../../../../../hook/useToast'
import { CHANNELTYPE, dataSendEvent, DataSendingForm, FIELDTYPE } from '../../../../../services/data'
import { formatNumber } from '../../../../../services/mixin'

import { ColDef, GridApi, RowSelectionOptions, SelectionChangedEvent } from 'ag-grid-community'
import { useSelector } from 'react-redux'
import { IGroupCampaign } from '../../../../../api/campaign/campaignApi'
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice'
import { CustomLoadingOverlayTable, dataPagination, disabledDate, fommatSelectOption, formatPrice } from '../../../../../until'
import { AddType, IPagination } from '../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup'
import { CONDITIONGROUP } from '../../../../Customers/CustomerGroup/Component/AddGroup/Component/PrivateGroup/AG_PrivateAutomatic'
import { ISelectedCustomer } from '../../../../Customers/CustomerGroup/Component/EditGroup/EditGroup'
import '../../CampaignSendsNotifications.scss'
import SelectCustomSearch, { UserValue } from '../../Component/SelectCustomSearch'
import ItemConditionDisplay from '../../../../Customers/CustomerGroup/Component/ViewGroup/components/ItemConditionDisplay'

import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import TextArea from 'antd/es/input/TextArea'
import useDebounce from '../../../../../hook/useDebounce'
import { getListConfigTemplate } from '../../../../../api/notificationTemplate/notificationTemplateApi'
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice'
import { CampaignStep, IDataFilterGroupList, InfoCampaignTmp, IVConditionFilterCampaim, useCustomerGroupContext } from '../../Create'
import ModalConditionCampaign, { filterInfoOperator } from '../../Create/Modal/ModalConditionCampaign'
import ModalGroupCus from '../../Create/Modal/ModalGroupCus'
import ModalAddCustomersManually from '../../Create/Modal/ModalAddCustomersManually'
import { channels, ChannelType, SendStrategy, SendTimeType } from '../../Create/Component/InfoCreate'
import { VoucherType } from '../../../VoucherCreate'

interface RowData {
  id: string;
  channelId?: number;
  brandId?: string;
  notificationTemplateId?: number;
}

// Map checkbox key → channel id (number)
const CHANNEL_TYPE_MAP: Record<string, number> = {
  SMS: 1,
  ZNS: 2,
  Email: 3,
};

const ALL_TYPE_OPTIONS = [
  { label: "SMS", value: 1, key: 1 },
  { label: "ZNS", value: 2, key: 2 },
  { label: "Email", value: 3, key: 3 },
];

export type ChildRef = {
  changeStepPreview: () => void;
};

const { Search } = Input;



export interface IChannelListTmp {
  channelId: number
  integrationProviderId?: number
  notificationTemplateId?: number

  sLIntegrationProvider: any
  sLNotificationTemplate: any
}

export interface IStatusSend {
  success: number
  failed: number
  notSent: number
}
export interface IChannelListTmpV9 {
  channelId: number
  brandId: number
  notificationTemplateId?: number
  categories?: string

  brands: selectOptionsApi.ISelectOption[]
  templates: selectOptionsApi.ISelectOption[]

  //cho chi tiết
  status?: IStatusSend
}

interface Props {
  loading: boolean

  memoizedColumnDefs: ColDef<any, any>[]
  refSelectionState: MutableRefObject<{
    // isInitialized: boolean;
    originalSelectableIds: number[];
    previousFilterKey: string;
  }>

  infoCampaign?: InfoCampaignTmp
  groupCustomerSelected: IGroupCampaign[]
  selectedIdCustomer: ISelectedCustomer[]
  selectedIdUnmatchedCustomers: Set<number>

  dataFilterMatchedCustomers: IDataFilterGroupList
  dataFilterUnmatchedCustomers: IDataFilterGroupList
  paginationMatchedCustomers: IPagination
  paginationUnmatchedCustomers: IPagination

  listMatchedCustomers: any[]
  listUnmatchedCustomers: any[]

  setStep: (value: number) => void
  setIsPrivateVoucherAdd: (value: boolean) => void
  setInfoCampaign?: (value?: InfoCampaignTmp) => void

  setGroupCustomerSelected: Dispatch<SetStateAction<IGroupCampaign[]>>
  setSelectedIdCustomer: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>>
  setSelectedIdUnmatchedCustomers: (data: Set<number>) => void;

  setDataFilterMatchedCustomers: (value: IDataFilterGroupList) => void
  setDataFilterUnmatchedCustomers: (value: IDataFilterGroupList) => void

  onPaginationMatchedCustomers: (page: number, pageSize: number) => void
  onPaginationUnmatchedCustomers: (page: number, pageSize: number) => void

  //dk
  isAutoCondition: boolean
  infoOperator: IVConditionFilterCampaim
  setInfoOperator: (value: IVConditionFilterCampaim) => void


}
const InfoEdit = forwardRef<ChildRef, Props>((props, ref) => {
  const {
    loading,
    refSelectionState,
    infoCampaign,
    groupCustomerSelected, selectedIdCustomer, selectedIdUnmatchedCustomers,

    dataFilterMatchedCustomers, dataFilterUnmatchedCustomers, paginationMatchedCustomers, paginationUnmatchedCustomers,

    listMatchedCustomers, listUnmatchedCustomers,
    setStep, setIsPrivateVoucherAdd,
    setInfoCampaign,
    setGroupCustomerSelected, setSelectedIdCustomer, setSelectedIdUnmatchedCustomers,

    setDataFilterMatchedCustomers, setDataFilterUnmatchedCustomers, onPaginationMatchedCustomers, onPaginationUnmatchedCustomers,
    //
    memoizedColumnDefs,

    //

    //dk
    isAutoCondition, infoOperator,
    setInfoOperator,
    //


  } = props

  const pushToast = useToast();
  const pushLoading = useLoading()
  const { unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const { sLCategoryCar, sLNationwide, sLTarget } = useCustomerGroupContext()


  useImperativeHandle(ref, () => ({
    changeStepPreview,
  }));


  const [form] = useForm()
  const isRestoringSelection = useRef(false);
  const isFirstLoadApi = useRef(true);
  const gridApiRef = useRef<GridApi | null>(null);

  const targetId = Form.useWatch('targetId', form)
  const informationChannel = Form.useWatch('informationChannel', form)



  const [sLtemplateOptions, setSLTemplateOptions] = useState<{ [key: string]: any[] }>({});
  const [slVoucherInCampaign, setSLVoucherInCampaign] = useState<selectOptionsApi.ISLVoucherInCampaign[]>([]);

  const [isMore, setMore] = useState<boolean>(true)
  const [openModalAddGroupCus, setOpenModalAddGroupCus] = useState(false)
  const [openModalAddCustomer, setOpenModalAddCustomer] = useState(false)
  const [openModalAddCondition, setOpenModalAddCondition] = useState(false)



  const { voucherTitle, setVoucherTitle } = useCustomerGroupContext()

  const [sendType, setSendType] = useState<SendStrategy>(SendStrategy.PRIORITY_BY_CHANNEL)
  const [sendTimeType, setSendTimeType] = useState<SendTimeType>(SendTimeType.NOW)

  // const [channelSelected, setChannelSelected] = useState<any[]>([])
  const [selectedIds, setSelectedIds] = useState<Set<Number>>(new Set());

  const [listGeneralConfiguration, setListGeneralConfiguration] = useState<{ [key: string]: any[] }>({})

  const [checkedChannels, setCheckedChannels] =
    useState<Record<ChannelType, boolean>>({
      SMS: false,
      ZNS: false,
      Email: false,
    });


  const infoOperatorApply = useMemo(() => {
    return filterInfoOperator(infoOperator);
  }, [infoOperator]);

  const isTargetVoucher = useMemo(() => {
    if (!targetId) return false

    return sLTarget.find(item => item.id === targetId)?.isVoucher ?? false
  }, [targetId, sLTarget])

  const isPublicVoucher = useMemo(() => {
    // console.log(informationChannel?.value, informationChannel)
    const informationChannelId = informationChannel?.value
    if (!informationChannelId) return false;

    const typeVoucher = slVoucherInCampaign.find((item) => item.id === informationChannelId)?.type
    const isPrivateVoucherAdd = (typeVoucher !== VoucherType.PUBLIC && Boolean(informationChannelId))
    setIsPrivateVoucherAdd(isPrivateVoucherAdd)
    return typeVoucher === VoucherType.PUBLIC
  }, [informationChannel, slVoucherInCampaign]);

  const isChosenGroup = useMemo(() => {
    if (isAutoCondition) return false;
    // console.log(informationChannel?.value || informationChannel ? isPublicVoucher : true)

    return (informationChannel?.value || informationChannel) ? isPublicVoucher : true;
  }, [isAutoCondition, informationChannel?.value, isPublicVoucher]);

  // Voucher không public (nhóm/cá nhân) đã được chọn -> khoá selection, chỉ hiển thị tệp KH của voucher
  const isVoucherLocked = useMemo(() => {
    return !!(informationChannel?.value || informationChannel) && !isPublicVoucher;
  }, [informationChannel, isPublicVoucher]);



  const selectedEditableCustomerIds = useMemo(() => {
    return selectedIdCustomer
      .filter(item => item.addType === 0)
      .map(item => item.customerId);
  }, [selectedIdCustomer]);

  const isHeaderCheckbox = useMemo(() => {
    if (!selectedIdCustomer.length) return true;
    const ids = selectedIdCustomer.filter(item => item.addType === 1);
    return !(ids.length > 0)
  }, [selectedIdCustomer]);

  //#region chon kh
  const rowSelection = useMemo<RowSelectionOptions>(() => ({
    mode: "multiRow",
    hideDisabledCheckboxes: true,
    headerCheckbox: isVoucherLocked ? false : isHeaderCheckbox,
    isRowSelectable: (node) => {
      // console.log(selectedEditableCustomerIds,(Number(node.id)));
      // console.log('node.id:', node.id);
      // console.log(isHeaderCheckbox,selectedEditableCustomerIds.includes(Number(node.id)));
      // return isHeaderCheckbox ? true : selectedEditableCustomerIds.includes(Number(node.id));
      const id = Number(node.id);

      if (isVoucherLocked) return true; // cho phép restore tick, bỏ chọn đã bị chặn ở onSelectionChanged

      const originalIds = refSelectionState.current.originalSelectableIds;

      // ưu tiên original ids nếu có
      const selectableIds = originalIds.length > 0 ? originalIds : selectedEditableCustomerIds;
      // console.log(selectableIds,originalIds, selectedEditableCustomerIds);


      return isHeaderCheckbox ? true : selectableIds.includes(id);
    }
  }), [selectedEditableCustomerIds, isHeaderCheckbox, isVoucherLocked, refSelectionState.current.originalSelectableIds]);

  const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

  // --- Grid ready ---
  const onGridReady = useCallback((params: { api: GridApi }) => {
    gridApiRef.current = params.api;
  }, []);

  // --- Selection change ---
  const onSelectionChanged = useCallback((event: SelectionChangedEvent) => {

    if (isRestoringSelection.current) return;

    // Voucher nhóm/cá nhân: khoá selection, không cho bỏ chọn
    if (isVoucherLocked) {
      isRestoringSelection.current = true;
      event.api.forEachNode((node: any) => {
        if (node.data && selectedIds.has(Number(node.data.id))) {
          node.setSelected(true, false, true);
        }
      });
      setTimeout(() => { isRestoringSelection.current = false; }, 0);
      return;
    }

    const api = event.api;
    const selectedNodes = api.getSelectedNodes().filter(n => n.data);
    const selectedIdsOnPage = selectedNodes.map(n => Number(n.data.id));


    const currentPageIds =
      (listMatchedCustomers).map((row: any) => Number(row.id));



    // --- Tạo bản sao của selectedIds hiện tại ---
    const nextSet = new Set(selectedIds);

    // --- Xác định phần tử được thêm và bị xóa trên trang HIỆN TẠI ---
    const added: number[] = [];
    const removed: number[] = [];

    // Kiểm tra từng ID trên trang hiện tại
    for (const id of currentPageIds) {
      // const isCurrentlySelected = selectedIdsOnPage.includes(id);
      // const wasPreviouslySelected = selectedIds.has(id);

      // if (isCurrentlySelected && !wasPreviouslySelected) {
      //   // ID mới được chọn
      //   added.push(id);
      //   nextSet.add(id);
      // } else if (!isCurrentlySelected && wasPreviouslySelected) {
      //   // ID bị bỏ chọn
      //   removed.push(id);
      //   nextSet.delete(id);
      // }

      // row hiện tại có được phép selectable không
      const isSelectable =
        isHeaderCheckbox ||
        (
          refSelectionState.current.originalSelectableIds.length > 0
            ? refSelectionState.current.originalSelectableIds
            : selectedEditableCustomerIds
        ).includes(id);

      // ❌ bỏ qua row không selectable
      if (!isSelectable) continue;

      const isCurrentlySelected =
        selectedIdsOnPage.includes(id);

      const wasPreviouslySelected =
        selectedIds.has(id);

      if (isCurrentlySelected && !wasPreviouslySelected) {
        added.push(id);
        nextSet.add(id);

      } else if (!isCurrentlySelected && wasPreviouslySelected) {
        removed.push(id);
        nextSet.delete(id);
      }
    }
    // console.log(added, removed);


    setSelectedIds(nextSet);

    // // 👉 Cập nhật danh sách selected account
    handleChangeSelectedCustomer(added, removed);
  }, [
    selectedIds, listMatchedCustomers, isVoucherLocked
  ]);

  // --- Cập nhật danh sách account được chọn ---
  const handleChangeSelectedCustomer = (itemsAdd: number[] = [], itemsRemove: number[] = []) => {


    setSelectedIdCustomer((prev) =>
      itemsAdd.length ?
        [
          ...prev,
          ...itemsAdd
            .filter((id) => !prev.some((u) => u.customerId === id))
            .map((id) => ({ customerId: id, addType: AddType.Manual })),
        ] :
        itemsRemove.length ?
          prev.filter((u) => !itemsRemove.includes(u.customerId)) :
          prev
    );
  };

  // --- Khôi phục selection khi data mới load ---
  useEffect(() => {
    if (gridApiRef.current && listMatchedCustomers) {
      isRestoringSelection.current = true;

      gridApiRef.current.forEachNode((node: any) => {
        if (node.data && (isVoucherLocked || selectedIds.has(Number(node.data.id)))) {
          node.setSelected(true, false, true);
        } else {
          node.setSelected(false, false, true);
        }
      });

      setTimeout(() => {
        isRestoringSelection.current = false;
      }, 0);
    }
  }, [
    selectedIds, listMatchedCustomers, isVoucherLocked
  ]);

  //------------------------------------ End SELECT

  useEffect(() => {
    const Ids = new Set(
      selectedIdCustomer.map(item => item.customerId)
    );
    setSelectedIds(Ids);
  }, [selectedIdCustomer])


  //#endregion


  //----------------------------------------------------------------------------------------------------------------------------------
  //    #region chọn nội dung kênh gửi

  const validateDuplicateTemplate = (index: number) => {
    return async (_: any, value: any) => {
      const rows = form.getFieldValue("channelList") || [];
      const current = rows[index];

      if (!current?.channelId || !current?.brandId || !value) {
        return Promise.resolve();
      }

      const isDuplicate = rows.some((row: any, i: number) => {
        if (i === index) return false;

        return (
          row?.channelId === current.channelId &&
          row?.brandId === current.brandId &&
          row?.notificationTemplateId === value
        );
      });

      if (isDuplicate) {
        return Promise.reject(
          new Error("Không được chọn cùng kênh gửi, brandname và mẫu thông báo!")
        );
      }

      return Promise.resolve();
    };
  };


  // ✅ Mới — check → hiện, bỏ tick → xóa
  const sLType = ALL_TYPE_OPTIONS.filter((opt) =>
    Object.entries(checkedChannels).some(
      ([key, checked]) => checked && CHANNEL_TYPE_MAP[key] === opt.value
    )
  );

  // Chi tiết tin xe
  const gListConfigTemplate = useDebounce(async (
    channel: CHANNELTYPE, index: number,
    brandId?: number, notificationTemplateId?: number

  ) => {
    const rows = form.getFieldValue("channelList") || [];

    //CASE 🟡 1. Reuse data từ row khác (chỉ khi chọn channel)
    if (!brandId && !notificationTemplateId) {
      // tìm row đã có cùng channel
      const existingRow = rows.find(
        (r: any, i: number) => i !== index && r.channelId === channel
      );

      if (existingRow?.brands && existingRow?.templates) {
        rows[index] = {
          ...rows[index],
          brands: existingRow.brands,
          templates: existingRow.templates,
        };

        form.setFieldsValue({ rows });
        return;
      }
    }

    pushLoading(true)
    const result = await getListConfigTemplate(
      permittedCategoryCarIds, channel,
      unitTemp, brandId, notificationTemplateId
    )
    if (result?.status) {

      // 🟡 CASE 2: brandId
      if (brandId) {
        rows[index] = {
          ...rows[index],
          brandId: brandId,
          templates: fommatSelectOption(result.data.templates),
          notificationTemplateId: undefined,
          categories: undefined
        };

        form.setFieldsValue({ rows });
        pushLoading(false)
        return
      }

      // 🔴 CASE 3: notificationTemplateId
      if (notificationTemplateId) {
        rows[index] = {
          ...rows[index],
          categories: result.data.categories
        };

        form.setFieldsValue({ rows });
        pushLoading(false)
        return
      }

      // 🟢 CASE 4: channel
      rows[index] = {
        ...rows[index],

        brands: fommatSelectOption(result.data.brandNames),
        // templates: fommatSelectOption(result.data.templates),
        // reset value khi đổi type
        brandId: undefined,
        notificationTemplateId: undefined,
        categories: undefined
      };

      form.setFieldsValue({ "channelList": rows });
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)



  const hasAnyChannel = Object.values(checkedChannels).some(Boolean);

  // ── 3. Handle channel checkbox change ────────────────────────────────────
  const handleChannelChange = (channel: string, checked: boolean) => {
    const prevHasChannel = Object.values(checkedChannels).some(Boolean);

    const next = { ...checkedChannels, [channel]: checked };
    setCheckedChannels(next);

    const nextHasChannel = Object.values(next).some(Boolean);

    const removedType = CHANNEL_TYPE_MAP[channel];

    // lấy rows từ Form
    const currentRows: RowData[] = form.getFieldValue("channelList") || [];

    let updatedRows = [...currentRows];

    // TH2: bỏ check → xóa row có type tương ứng
    if (!checked) {
      updatedRows = updatedRows.filter((row) => row?.channelId !== removedType);
    }

    // tính allowed types
    const allowedTypes = new Set(
      Object.entries(next)
        .filter(([, v]) => v)
        .map(([k]) => CHANNEL_TYPE_MAP[k])
    );

    // reset type không hợp lệ
    updatedRows = updatedRows.map((row) => {
      if (!row.channelId) return row;

      if (!allowedTypes.has(row.channelId)) {
        return { ...row, type: undefined, brand: undefined, mauThongBao: undefined };
      }

      return row;
    });

    // TH1: vừa bật channel đầu tiên mà chưa có row
    if (!prevHasChannel && nextHasChannel && updatedRows.length === 0) {
      updatedRows.push({
        id: Date.now().toString(),
        channelId: undefined,
        brandId: undefined,
        notificationTemplateId: undefined,
      });
    }

    // cập nhật lại Form
    form.setFieldsValue({
      "channelList": updatedRows,
    });

    // form.setFieldValue(["channels", channel], checked);

    const selectedChannels = Object.entries(next).filter(([, v]) => v).map(([k]) => k);
    form.setFieldValue('channels', selectedChannels.length > 0 ? selectedChannels : undefined);

  };


  // #endregion
  //----------------------------------------------------------------------------------------------------------------------------------

  const gSlVoucherInCampaign = useDebounce(async (search?: string) => {
    const result = await selectOptionsApi.getSlVoucherInCampaign(search, infoCampaign?.id);
    if (result?.status) {
      setSLVoucherInCampaign(result.data);
    } else {
      pushToast(result?.message, "error");
    }
  }, 500)

  const changeStepPreview = () => {
    form.submit()
  };

  const removeGroupCustomerSelected = (id: number) => {
    setGroupCustomerSelected((prev) =>
      prev.filter((item: IGroupCampaign) => Number(item.id) !== Number(id))
    );
  };


  const onSubmitFormModalSaveFilter = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setOpenModalAddCondition(false)
      pushToast(message, "success")
    }
    else {
      pushToast(message, "warning")
    }
  }


  const onFinish: FormProps["onFinish"] = async (values) => {

    let formattedDate = undefined
    let formattedTime = undefined
    let formattedTimeOption = undefined
    let sendHourOption = undefined

    const {
      title, description, targetId, sendDate, sendTime, sendTimeOption, sendBeforeUnit,
      sendInAdvance, sendEvent, phoneField, channelList, sendHour
    } = values

    if (sendDate && sendTime) {
      formattedDate = dayjs(sendDate.toISOString()).format('YYYY/MM/DD');
      formattedTime = dayjs(sendTime.toISOString()).format('HH:mm');
    }

    if (sendHour) {
      sendHourOption = dayjs(sendHour.toISOString()).format('HH:mm');
    }


    const infoCampaignTmp = {
      title: title,
      description,
      // adminId: ,
      targetId: targetId,
      type: sendType,
      role: sendTimeType,
      // auto: ,

      // customerId: ,
      groupCustomerId: infoCampaign?.groupCustomerId,
      channelList: channelList,
      // rows: rows,
      dateSend: formattedDate,
      timeSend: formattedTime,
      // phoneField,
      // new
      // sendTimeOption: formattedTimeOption,
      sendEvent: sendEvent,
      sendInAdvance,
      sendBeforeUnit: "day",//
      sendHour: sendHourOption,

    }

    setInfoCampaign?.(infoCampaignTmp)
    setStep(CampaignStep.PREVIEW)
  };
useEffect(() => {
  if (!infoCampaign) return;

  const channelList = infoCampaign.channelList || [];

  const {
    title,
    description,
    targetId,
    type,
    role,
    sendEvent,
    sendInAdvance,
  } = infoCampaign;

  const nextChecked: Record<ChannelType, boolean> = {
    SMS: false,
    ZNS: false,
    Email: false,
  };

  channelList.forEach((item) => {
    switch (item.channelId) {
      case CHANNELTYPE.SMS:
        nextChecked.SMS = true;
        break;

      case CHANNELTYPE.ZNS:
        nextChecked.ZNS = true;
        break;

      case CHANNELTYPE.EMAIL:
        nextChecked.Email = true;
        break;
    }
  });

  const selectedChannels = channelList
    .map((item) => {
      switch (item.channelId) {
        case CHANNELTYPE.SMS:
          return 'SMS';

        case CHANNELTYPE.ZNS:
          return 'ZNS';

        case CHANNELTYPE.EMAIL:
          return 'Email';

        default:
          return null;
      }
    })
    .filter(Boolean);

  setCheckedChannels(nextChecked);

  setSendTimeType(
    role as SendTimeType
  );

  const dateSendTmp =
    infoCampaign.dateSend
      ? dayjs(infoCampaign.dateSend)
      : undefined;

  const timeSendTmp =
    infoCampaign.timeSend
      ? dayjs(
          infoCampaign.timeSend,
          'HH:mm'
        )
      : undefined;

  form.setFieldsValue({
    title: title ?? '',
    description: description ?? '',
    targetId,

    channels: selectedChannels,
    channelList,

    type,
    role,

    sendDate: dateSendTmp,
    sendTime: timeSendTmp,

    sendEvent,
    sendInAdvance,

    sendHour:
      role === SendTimeType.OPTIONS
        ? timeSendTmp
        : undefined,
  });
}, [infoCampaign, form]);

  // useEffect(() => {
  //   if (infoCampaign && isFirstLoadApi.current) {
  //     isFirstLoadApi.current = false

  //     const channelList = infoCampaign.channelList || [];
  //     const { title, description, targetId, voucherId, type, role, sendEvent, sendInAdvance } = infoCampaign


  //     const nextChecked: Record<ChannelType, boolean> = {
  //       SMS: false,
  //       ZNS: false,
  //       Email: false,
  //     };

  //     channelList.forEach((item) => {
  //       switch (item.channelId) {
  //         case CHANNELTYPE.SMS:
  //           nextChecked.SMS = true;
  //           break;
  //         case CHANNELTYPE.ZNS:
  //           nextChecked.ZNS = true;
  //           break;
  //         case CHANNELTYPE.EMAIL:
  //           nextChecked.Email = true;
  //           break;
  //       }
  //     });
  //     const selectedChannels = channelList.map((item) => {
  //       switch (item.channelId) {
  //         case CHANNELTYPE.SMS:
  //           return "SMS";
  //         case CHANNELTYPE.ZNS:
  //           return "ZNS";
  //         case CHANNELTYPE.EMAIL:
  //           return "Email";
  //         default:
  //           return null;
  //       }
  //     }).filter(Boolean);

  //     setCheckedChannels(nextChecked);
  //     setSendTimeType(role as SendTimeType)

  //     const dateSendTmp = infoCampaign.dateSend ? dayjs(infoCampaign.dateSend) : undefined;
  //     const timeSendTmp = infoCampaign?.timeSend ? dayjs(infoCampaign.timeSend, "HH:mm") : undefined;

  //     form.setFieldsValue({
  //       title,
  //       description,
  //       targetId,
  //       // informationChannel: informationChannelTmp, //0705 set giá trị khi mà api chạy xong để gắn info
  //       channels: selectedChannels,
  //       channelList,
  //       type,
  //       role,
  //       sendDate: dateSendTmp,
  //       sendTime: timeSendTmp,
  //       sendEvent,
  //       sendInAdvance,
  //       sendHour: role === SendTimeType.OPTIONS ? timeSendTmp : undefined
  //     })
  //   }

  // }, [infoCampaign])

  // Khi brands/templates của channelList được nạp sau (gDatachannelList ở bước Preview),
  // merge vào form để Select hiển thị đúng label thay vì id thô.
  useEffect(() => {
    if (!infoCampaign?.channelList?.length) return;

    const currentRows = form.getFieldValue("channelList") || [];
    const nextRows = currentRows.map((row: any, index: number) => {
      const src = infoCampaign.channelList?.[index];
      if (!src) return row;
      return {
        ...row,
        brands: src.brands ?? row?.brands,
        templates: src.templates ?? row?.templates,
      };
    });

    form.setFieldsValue({ channelList: nextRows });
  }, [infoCampaign?.channelList])

  //0705 set giá trị khi mà api chạy xong để gắn info
  useEffect(() => {
    if (!slVoucherInCampaign.length || !infoCampaign?.voucherId) return;

    const found = slVoucherInCampaign.find(
      item => item.id === infoCampaign?.voucherId
    );
    const informationChannelTmp: UserValue | undefined = found ? {
      label: found.title,
      value: found.id
    } : undefined;
    setVoucherTitle(informationChannelTmp)
    form.setFieldsValue({
      informationChannel: informationChannelTmp
    })
  }, [slVoucherInCampaign, infoCampaign?.voucherId]);

  //gọi api đối vs mục tiêu vc
  useEffect(() => {
    if (isTargetVoucher && !slVoucherInCampaign.length)
      gSlVoucherInCampaign()
  }, [isTargetVoucher])

  //rs khi mà từ có chọn vc rồi xóa
  useEffect(() => {
    if (!informationChannel) {
      setVoucherTitle(undefined)
      form.setFieldsValue({
        informationChannel: undefined
      })
    }
  }, [informationChannel])

  //rs khi mà chọn nhóm VC công khai rồi chuyển sang cá nhâ
  useEffect(() => {
    if (!isPublicVoucher) {
      // setInfoCampaign?.({ ...infoCampaign, groupCustomerId: undefined })
      setGroupCustomerSelected([])
    }
  }, [isPublicVoucher])


  
  return (
    <div className='custom-page-css flex flex-col gap-4'>
      <ModalGroupCus
        infoCampaign={infoCampaign}
        open={openModalAddGroupCus}
        groupCustomerSelected={groupCustomerSelected}

        setGroupCustomerSelected={setGroupCustomerSelected}

        onClose={() => setOpenModalAddGroupCus(false)}
      />

      <ModalAddCustomersManually
        isOpen={openModalAddCustomer}

        memoizedColumnDefs={memoizedColumnDefs}

        dataFilterUnmatchedCustomers={dataFilterUnmatchedCustomers}
        paginationUnmatchedCustomers={paginationUnmatchedCustomers}

        selectedIdUnmatchedCustomers={selectedIdUnmatchedCustomers}

        listUnmatchedCustomers={listUnmatchedCustomers}

        setDataFilterUnmatchedCustomers={setDataFilterUnmatchedCustomers}
        onPaginationUnmatchedCustomers={onPaginationUnmatchedCustomers}

        setSelectedIdUnmatchedCustomers={setSelectedIdUnmatchedCustomers}

        closeModal={() => setOpenModalAddCustomer(false)}
      />

      <ModalConditionCampaign
        isOpen={openModalAddCondition}

        infoOperator={infoOperator}

        onSubmitFormModal={onSubmitFormModalSaveFilter}
        setInfoOperator={setInfoOperator}

        closeModal={() => setOpenModalAddCondition(false)}

      />

      <Form
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className="custom-page-css flex flex-col gap-4  form-add-campaign"
      >
        <div className="custom-page-css flex flex-col gap-3">
          <span className="font-medium lh-24 fsz-16">{isAutoCondition ? 'Tên chiến dịch tự động' : 'Tên chiến dịch thủ công'}
            <span className='custom-page-css pl-1 text-FF1D1D'>*</span>
          </span>
          <Form.Item<FIELDTYPE>
            name="title"
            rules={[{ required: true, message: 'Vui lòng nhập tên chương trình!' }]}
            className='custom-input-search'
          >
            <Input
              placeholder="Tên chương trình"
              className="custom-input-css custom-page-css border py-6px "
            />
          </Form.Item>

        </div>
        {/* <div className="custom-page-css flex flex-col gap-3"> */}
        <span className="font-medium lh-24 fsz-16">Mô tả</span>
        <Form.Item<FIELDTYPE>
          name="description"
          className='custom-input-search'
        >
          <TextArea
            placeholder="Nhập mô tả"
            className=""
          />
        </Form.Item>

        {/* </div> */}
        <div className="custom-page-css flex flex-col gap-3 custom-select-multi">
          <span className="font-medium lh-24 fsz-16 ">Mục tiêu</span>
          <Form.Item
            className="custom-page-css flex gap-3"
            name="targetId"
            rules={[
              {
                required: true,
                message: 'Vui lòng chọn ít nhất 1 mục tiêu!',
              },
            ]}
          >
            <Radio.Group
              className="rs-radio-group rs-radio-group--button flex flex-wrap gap-3"
            >
              {
                sLTarget && sLTarget.map((item, i) =>
                  <Radio.Button
                    key={i}
                    value={item.id}
                    className='custom-page-css flex items-center gap-4 border rounded custom-radio-button'
                    style={{
                      borderColor: `#${item?.colorBorder.trim()}`,
                      color: `#${item?.colorText.trim()}`,
                      backgroundColor: `#${item?.bgColor.trim()}`, // 1A = 10% opacity
                    }}
                  >
                    <SvgIconWithMask
                      src={URL_TEMPLATE_IMG + item.icon}
                      onError={<TagOutlined />}
                      color={`#${item.colorText}`}
                      size={18}
                    />
                    <span className=''>{item.title}</span>
                  </Radio.Button>
                )
              }
            </Radio.Group>
          </Form.Item>

        </div>
        {
          isTargetVoucher && (
            <div className="custom-page-css flex flex-col gap-3">
              <span className="font-medium lh-24 fsz-16 ">Tên chương trình voucher<span className='custom-page-css pl-1 text-FF1D1D'>*</span></span>
              <Form.Item
                name='informationChannel'
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn tên chương trình voucher",
                  },
                ]}
              >
                <Select
                  placeholder="Tên chương trình voucher"
                  className="custom-page-css border rounded overflow-hidden"

                  showSearch
                  allowClear
                  filterOption={false}
                  labelInValue
                  options={
                    slVoucherInCampaign?.map(item => ({
                      label: item.title,
                      value: item.id,
                    })) || []}
                  onSearch={(value) => gSlVoucherInCampaign(value)}
                  onChange={(data) => setVoucherTitle(data)}
                />
              </Form.Item>
            </div>
          )
        }

        <div className="custom-page-css flex  items-center justify-between">
          <span className="font-medium lh-24 fsz-16" style={{ whiteSpace: 'nowrap' }}>Kênh gửi</span>
          <Form.Item label=""
            name='channels'
            rules={[{
              validator: (_, value) =>
                value && value.length > 0
                  ? Promise.resolve()
                  : Promise.reject(new Error('Vui lòng chọn kênh gửi!')),
            }]}
          >
            {
              channels.map((item, i) => (
                <Checkbox
                  key={i}
                  className="rs-checkbox"
                  checked={checkedChannels[item.key as ChannelType]}
                  onChange={(e) => handleChannelChange(item.key, e.target.checked)}
                >
                  {item.title}
                </Checkbox>
              ))
            }
          </Form.Item>
        </div>



        {
          hasAnyChannel && (
            <div className="block">
              <span className="font-medium lh-24 fsz-16">Chọn mẫu nội dung cho kênh gửi</span>
              <Form.List name="channelList">
                {(fields, { add, remove, move }) => (
                  <Form.Item >
                    <DragDropContext
                      onDragEnd={(result) => {
                        if (!result.destination) return;
                        move(result.source.index, result.destination.index);
                      }}
                    >
                      <Droppable droppableId="channelList">
                        {(dropProvided) => (
                          <div
                            ref={dropProvided.innerRef}
                            {...dropProvided.droppableProps}
                          >
                            {fields.map((field, index) => (
                              <Draggable
                                key={field.key}
                                draggableId={String(field.key)}
                                index={index}
                              >
                                {(dragProvided) => (
                                  <div
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    style={{
                                      display: "flex",
                                      gap: 10,
                                      padding: 10,
                                      marginBottom: 8,
                                      borderRadius: 6,
                                      background: "#fff",
                                      alignItems: "start",
                                      ...dragProvided.draggableProps.style,
                                    }}
                                  >

                                    <div {...dragProvided.dragHandleProps}>⋮⋮</div>
                                    {/* TYPE */}
                                    <Form.Item
                                      name={[field.name, "channelId"]}
                                      style={{ flex: 1, marginBottom: 0 }}
                                      rules={[{ required: true, message: "Chọn Type" }]}

                                    >
                                      <Select
                                        placeholder="Chọn Type"
                                        className='custom-page-css custom-page-css-CampaignSends border rounded overflow-hidden '
                                        options={sLType}
                                        // style={{ width: '100%' }}
                                        onChange={(value) => gListConfigTemplate(value, index)}
                                      />
                                    </Form.Item>

                                    {/* BRAND + TEMPLATE phụ thuộc TYPE */}
                                    <Form.Item
                                      shouldUpdate={(prev, cur) =>
                                        prev.channelList?.[index]?.type !== cur.channelList?.[index]?.type
                                      }
                                      noStyle
                                    >
                                      {({ getFieldValue }) => {

                                        const row = getFieldValue(["channelList", index]) ?? {};

                                        const channelId = row.channelId as number | undefined;
                                        const brandId = row.brandId as number | undefined;

                                        const brands = row.brands ?? [];
                                        const templates = row.templates ?? []

                                        return (
                                          <>
                                            {/* BRAND */}
                                            <Form.Item
                                              name={[field.name, "brandId"]}
                                              style={{ flex: 2, marginBottom: 0 }}
                                              rules={[
                                                { required: true, message: "Vui lòng chọn brandname" },
                                                { validator: validateDuplicateTemplate(index) },
                                              ]}
                                            >
                                              <Select
                                                placeholder="Chọn Brandname"
                                                disabled={!channelId}
                                                options={brands}
                                                className="custom-page-css custom-page-css-CampaignSends border rounded overflow-hidden w-full"
                                                style={{ width: "100%" }}
                                                onChange={(value) => gListConfigTemplate(
                                                  channelId, index,
                                                  value, undefined
                                                )}
                                              />
                                            </Form.Item>

                                            {/* TEMPLATE */}
                                            <Form.Item
                                              name={[field.name, "notificationTemplateId"]}
                                              style={{ flex: 2, marginBottom: 0 }}
                                              dependencies={["channelList"]}

                                              rules={[
                                                { required: true, message: "Vui lòng chọn mẫu thông báo" },
                                                { validator: validateDuplicateTemplate(index) }
                                              ]}
                                            >
                                              <Select
                                                placeholder="Chọn mẫu thông báo"
                                                disabled={!brandId}
                                                options={templates}
                                                className="custom-page-css custom-page-css-CampaignSends border rounded overflow-hidden w-full"
                                                style={{ width: "100%" }}
                                                onChange={(value) => gListConfigTemplate(
                                                  channelId, index,
                                                  undefined, value
                                                )}
                                              />
                                            </Form.Item>

                                            <Form.Item
                                              name={[field.name, "categories"]}
                                              style={{ flex: 2, marginBottom: 0 }}
                                            >
                                              <Input
                                                placeholder="Thương hiệu hãng xe"
                                                disabled
                                                className="custom-input-css custom-page-css border  "
                                              />
                                            </Form.Item>
                                          </>
                                        );
                                      }}
                                    </Form.Item>

                                    <Button
                                      disabled={fields.length <= 1}
                                      danger
                                      icon={<DeleteFilled />}
                                      className="custom-page-css  ml-3 border"
                                      onClick={() => remove(field.name)}
                                    >
                                    </Button>

                                  </div>

                                )}

                              </Draggable>

                            ))}

                            {dropProvided.placeholder}

                          </div>
                        )}

                      </Droppable>

                    </DragDropContext>
                    <Button
                      type="link"
                      icon={<PlusOutlined />}
                      className="custom-page-css mt-2 ml-3 border-096DD9"
                      onClick={() =>
                        add({
                          type: undefined,
                          brand: undefined,
                          mauThongBao: undefined
                        })
                      }
                    >
                      Thêm brandname
                    </Button>

                  </Form.Item>
                )}
              </Form.List>
            </div>
          )}
        <div className="custom-page-css flex  items-center justify-between">
          <span className="font-medium lh-24 fsz-16">Hình thức</span>
          <Select
            defaultValue={DataSendingForm[sendType].label}

            className="custom-page-css rounded border overflow-hidden cus-css-sl-w-full"

            options={DataSendingForm}
            onSelect={(val) => setSendType(+val)}
          />
        </div>

        <Alert
          message={sendType === SendStrategy.PRIORITY_BY_CHANNEL ? '  Khách đã nhận thông báo ở kênh này thì không gửi ở kênh khác' : 'Một khách có thể nhận nhiều nội dung ở nhiều kênh'}
          type="info"
          showIcon
          closable
          className="rs-alert"
        />



        <div className="custom-page-css flex flex-col">
          <div className="custom-page-css flex  items-center justify-between">
            <span className="font-medium lh-24 fsz-16">Thời gian gửi</span>
            <Radio.Group
              defaultValue={sendTimeType}
              value={sendTimeType}
              className="rs-radio-group"
              onChange={(e) => setSendTimeType(e.target.value)}
            >
              <Radio.Button
                value={SendTimeType.NOW}
              >
                Tức thì
              </Radio.Button>
              <Radio.Button
                value={SendTimeType.SCHEDULED}
              >
                Lên lịch
              </Radio.Button>
              <Radio.Button
                value={SendTimeType.OPTIONS}
              >
                Tuỳ chọn
              </Radio.Button>
            </Radio.Group>
          </div>

          {
            sendTimeType === SendTimeType.SCHEDULED &&
            <div className="custom-page-css flex gap-3">
              <Form.Item
                name='sendDate'
                rules={[{ required: true, message: 'Vui lòng chọn ngày gửi!' }]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  placeholder="Chọn ngày"
                  className="custom-input-date"
                  popupClassName="rs-date-picker-dropdown"
                  disabledDate={disabledDate}
                />
              </Form.Item>
              <Form.Item
                name='sendTime'
                rules={[{ required: true, message: 'Vui lòng chọn giờ gửi!' }]}
              >
                <TimePicker
                  placeholder="Chọn giờ"
                  className="custom-input-date"
                  popupClassName="rs-date-picker-dropdown"
                  minuteStep={30}
                  format={'HH:mm'}
                />
              </Form.Item>
            </div>
          }

          {
            sendTimeType === SendTimeType.OPTIONS &&
            <Row gutter={16} className='pt-3 custom-page-css h-66-px'>
              {/* Sự kiện kích hoạt */}
              <Col span={8}>
                <Form.Item
                  layout='vertical'
                  label={<span className='font-medium lh-24 fsz-16'>Sự kiện kích hoạt</span>}
                  name="sendEvent"
                  rules={[{ required: true, message: "Vui lòng chọn sự kiện kích hoạt" }]}
                >
                  <Select
                    showSearch
                    placeholder="Chọn sự kiện"
                    className='custom-page-css border rounded overflow-hidden'
                    options={dataSendEvent}

                  // onSearch={debouncedSearch}
                  />
                </Form.Item>
              </Col>

              {/* Tin nhắn sẽ gửi trước */}
              <Col span={8}>
                <Form.Item
                  label={<span className='font-medium lh-24 fsz-16'>Tin nhắn sẽ gửi trước</span>}
                  layout='vertical'
                >
                  <Row gutter={8}>
                    <Col flex='1'>
                      <Form.Item
                        name="sendInAdvance"
                        rules={[{ required: true, message: 'Vui lòng nhập số lượng' }]}
                        style={{ marginBottom: 0 }}
                      >
                        <InputNumber
                          min={0}
                          style={{ width: "100%" }}
                          className='custom-input-css custom-page-css border'
                        // placeholder="1"
                        />
                      </Form.Item>
                    </Col>

                    <Col flex="1">
                      <Form.Item
                      // name="sendBeforeUnit"
                      // rules={[{ required: true, message: 'Vui lòng chọn đơn vị thời gian' }]}
                      // style={{ marginBottom: 0 }}
                      >
                        <span className='pt-1'>Ngày</span>
                        {/* <Select
                                                    placeholder="Ngày"
                                                    className='custom-page-css border rounded overflow-hidden'
                                                    options={[
                                                        { value: "day", label: 'Ngày' },
                                                        { value: "hour", label: 'Giờ' },
                                                    ]}
                                                /> */}
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>

              {/* Gửi vào thời gian */}
              <Col span={8}>
                <Form.Item
                  label={<span className='font-medium lh-24 fsz-16'>Gửi vào thời gian</span>}
                  layout='vertical'
                  rules={[{
                    required: true,
                    message: 'Vui lòng chọn thời gian gửi'
                  }]}
                >
                  <Row gutter={8}>
                    <Col flex="auto">
                      <Form.Item name="sendHour" noStyle>
                        <TimePicker
                          className='custom-input-date custom-page-css border rounded overflow-hidden'
                          style={{ width: "100%" }}
                          format="HH:mm"
                          placeholder="Chọn giờ"
                          disabledTime={() => {
                            const beforeVal = form.getFieldValue('sendInAdvance');
                            if (beforeVal !== 0) return {};
                            const now = new Date();
                            const currentHour = now.getHours();
                            const currentMinute = now.getMinutes();
                            return {
                              disabledHours: () => Array.from({ length: currentHour }, (_, i) => i), disabledMinutes: (selectedHour: number) =>
                                selectedHour === currentHour
                                  ? Array.from({ length: currentMinute + 1 }, (_, i) => i)
                                  : [],
                            };
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          }

        </div>

      </Form >
      {
        Boolean(isAutoCondition) &&
        <div className="block pt-4 custom-page-css flex flex-col gap-3">
          <div className="custom-page-css flex  items-center justify-between">
            <span className="font-medium lh-24 fsz-16">Điều kiện lọc </span>
            <div className="custom-page-css flex  items-center gap-2">
              <button className='custom-page-css flex  items-center gap-2 border-none bg-transparent px-4 py-1'
                onClick={() => setOpenModalAddCondition(true)}
              >
                <div className='custom-page-css flex items-center justify-center rounded-full' style={{
                  height: 20,
                  width: 20,
                  backgroundColor: '#98a2b34d',
                }}>
                  <PlusOutlined style={{ color: '#98A2B3' }} />
                </div>
                <span className='custom-page-css text-667085 text-sm font-medium'>
                  Thiết lập điều kiện {infoOperatorApply.typeCondition !== CONDITIONGROUP.ALL ? (infoOperatorApply.conditions.length > 0 ? `(${infoOperatorApply.conditions.length} tiêu chí đang áp dụng)` : '') : '(1 tiêu chí đang áp dụng)'}
                </span>
              </button>
              {
                (isMore) ?
                  <UpOutlined className='custom-page-css text-base text-98A2B3' onClick={() => setMore(!isMore)} /> :
                  <DownOutlined className='custom-page-css text-base text-98A2B3' onClick={() => setMore(!isMore)} />
              }

            </div>

          </div>
          {/* đã chọn nhóm thì hiển thị >< chưa thì hiển thị empty */}
          {
            (infoOperatorApply.conditions.length > 0 || infoOperatorApply.typeCondition === CONDITIONGROUP.ALL) ?
              <div className={`${infoOperatorApply.typeCondition !== CONDITIONGROUP.ALL ? '' : 'd-none'} custom-page-css w-full flex flex-col border-b pb-2`}>
                <div className="custom-page-css w-full flex flex-1 items-center justify-between gap-2">
                </div>
                {isMore &&
                  <div className="custom-page-css flex flex-col gap-2 flex-1">
                    <div className="custom-page-css flex gap-2 flex-1">
                      <div className="custom-page-css flex flex-col gap-2 flex-1">
                        <span className='custom-page-css text-base text-344054 font-medium'>Trường</span>

                      </div>
                      <div className="custom-page-css flex flex-col gap-2 flex-1">
                        <span className='custom-page-css text-base text-344054 font-medium'>Điều kiện</span>
                      </div>
                      <div className="custom-page-css flex flex-col gap-2 flex-1">
                        <span className='custom-page-css text-base text-344054 font-medium'>Giá trị</span>
                      </div>
                    </div>
                    <div className="custom-page-css flex flex-col flex-1">
                      {
                        infoOperatorApply.conditions.map((item, i) => (
                          <div
                            key={i}
                            className="custom-page-css flex gap-2 flex-1"
                          >
                            <div className="custom-page-css flex flex-col gap-2 flex-1">
                              <span className='custom-page-css text-base text-344054 font-regular'>
                                {item.CustomerField?.label}
                              </span>
                            </div>
                            <div className="custom-page-css flex flex-col gap-2 flex-1">
                              <span className='custom-page-css text-base text-344054 font-regular'>
                                {item.condition?.label}
                              </span>
                            </div>
                            <div className="custom-page-css flex gap-2 flex-1">
                              <ItemConditionDisplay
                                item={item}
                              />
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                }
              </div>
              :
              <div className="custom-page-css w-full flex flex-col items-center justify-center gap-3">
                <img src={empty_image_cus} alt="" />
                <span className='custom-page-css text-sm font-regular text-667085'>Chưa có điều kiện nào,
                  <span className='custom-page-css text-sm font-regular text-1890FF cursor-pointer'
                    onClick={() => setOpenModalAddGroupCus(true)}
                  >thiết lập điều kiện ngay</span>
                </span>
              </div>
          }
        </div>
      }
      {
        isChosenGroup &&
        <div className="block pt-4 custom-page-css flex flex-col gap-3">
          <div className="custom-page-css flex  items-center justify-between">
            <span className="font-medium lh-24 fsz-16">
              Danh sách nhóm khách hàng {
                groupCustomerSelected?.length ?
                  `(${groupCustomerSelected.length})` :
                  ''
              }
            </span>
            <button className='custom-page-css flex  items-center gap-2  border-none bg-transparent px-4 py-1'
              onClick={() => setOpenModalAddGroupCus(true)}
            >
              <div className='custom-page-css flex items-center justify-center rounded-full' style={{
                height: 20,
                width: 20,
                backgroundColor: '#98a2b34d',
              }}>
                <PlusOutlined style={{ color: '#98A2B3' }} />
              </div>
              <span className='custom-page-css text-667085 text-sm font-medium'>Chọn nhóm khách hàng</span>

            </button>

          </div>
          {/* đã chọn nhóm thì hiển thị >< chưa thì hiển thị empty */}
          {
            groupCustomerSelected?.length ?
              <div className="custom-page-css w-full flex  items-center  gap-2 flex-wrap">
                {
                  groupCustomerSelected?.map(item => (
                    <div key={item.id} className="custom-page-css flex  items-center  gap-2 rounded border px-3 py-1">
                      <span className='custom-page-css text-sm font-regular text-667085'>
                        {item.title} ({formatPrice(item.total)})
                      </span>
                      <CloseOutlined
                        onClick={() => removeGroupCustomerSelected(item.id)}
                        style={{ fontSize: 10, color: '#89898a' }}
                      />
                    </div>
                  ))
                }

              </div>
              :
              <div className="custom-page-css w-full flex flex-col items-center justify-center gap-3">
                <img src={empty_image_cus} alt="" />
                <span className='custom-page-css text-sm font-regular text-667085'>Chưa có nhóm khách hàng nào,
                  <span className='custom-page-css text-sm font-regular text-1890FF cursor-pointer pl-1'
                    onClick={() => setOpenModalAddGroupCus(true)}
                  >thêm ngay</span>
                </span>
              </div>
          }
        </div>
      }

      <div className="block pt-4 custom-page-css flex flex-col gap-3">
        <div className="custom-page-css flex  items-center justify-between">
          <span className="font-medium lh-24 fsz-16">Danh sách khách hàng </span>
          {
            // (groupCustomerSelected?.length || isAutoCondition) ? (
            (groupCustomerSelected?.length && !isVoucherLocked) ? (
              <button className='custom-page-css flex  items-center gap-2  border-none bg-transparent px-4 py-1'
                onClick={() => setOpenModalAddCustomer(true)}
              >
                <div className='custom-page-css flex items-center justify-center rounded-full' style={{
                  height: 20,
                  width: 20,
                  backgroundColor: '#98a2b34d',
                }}>
                  <PlusOutlined style={{ color: '#98A2B3' }} />
                </div>
                <span className='custom-page-css text-667085 text-sm font-medium'>Chọn khách hàng</span>
              </button>
            ) : (
              null
            )
          }
        </div>
        {
          !groupCustomerSelected?.length ? (
            <div className="custom-page-css flex items-start gap-2">
              <div className="custom-page-css h-fit flex-1 d-flex  gap-2 overflow-hidden">
                <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                  <div className="d-flex align-center w-full">

                    <TreeSelect
                      // className={'w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none no-focus-border'}
                      className='custom-page-css bg-FCFCFD-ant-select w-full  border-none no-focus-border overflow-hidden'
                      multiple
                      showSearch
                      placeholder="Chọn đơn vị"
                      allowClear
                      value={dataFilterMatchedCustomers?.listUnit}
                      treeDefaultExpandAll={false}
                      treeData={sLNationwide}
                      filterTreeNode={(input: string, option: any) =>
                        typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, listUnit: e })}
                    />
                  </div>
                </div>
              </div>

              <div className="custom-page-css h-fit flex-1 d-flex gap-2 overflow-hidden">
                <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center py-2-px justify-between overflow-hidden">
                  <div className="d-flex align-center w-full">
                    <Select
                      showSearch={false}
                      allowClear
                      mode="multiple"
                      // className="w-full text-left text-span-select  bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                      className='w-full font-regular p-none-select line-none line-none-item inline-none size-selector border-none '
                      popupClassName="position-dropdow custome-select-item h-popUp"
                      variant="borderless"
                      placeholder="Thương hiệu"
                      options={sLCategoryCar}
                      value={dataFilterMatchedCustomers?.listCategoryCar}
                      onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, listCategoryCar: e })}
                    />
                  </div>
                </div>
              </div>
              <div className='custom-page-css  h-36px flex flex-2'>
                <div className="custom-page-css custom-input-search w-full flex items-center justify-between flex-2 border-F2F4F7 bg-FCFCFD rounded-2  pl-3  overflow-hidden">
                  <input
                    placeholder="Tìm kiếm thông tin khách hàng"
                    // className='custome-select-t w-full border-none h-full custom-page-css'
                    className=' border-none  custom-page-css w-full border-none'
                    value={dataFilterMatchedCustomers.search}
                    onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, search: e.target.value })}
                  />
                  <div className="border-l-F2F4F7 h-full d-flex align-center">
                    <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            null
          )
        }
        <div className="custom-page-css w-full flex flex-col gap-3">
          <div className="custom-page-css flex items- gap-1">
            <span className='custom-page-css text-base text-4B4B4B font-regular'>Đã chọn:</span>
            <span className='custom-page-css text-base text-344054 font-regular'>{formatPrice(isVoucherLocked ? paginationMatchedCustomers.total : selectedIdCustomer.length)} khách hàng</span>
            {/* <span className='custom-page-css text-base text-344054 font-regular'>{formatNumber(selectedIds?.size)} khách hàng</span> */}
          </div>
        </div>

        <div className="ag-theme-alpine custom-table-ag custom-h-modal"
          style={{ width: '100%', height: listMatchedCustomers.length === 0 ? 250 : listMatchedCustomers.length < 10 ? listMatchedCustomers.length * 65 + 65 : 650 }}

        >
          <AgGridReact
            // domLayout="autoHeight"
            className="my-auto-height-grid"
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            loading={loading}
            loadingOverlayComponent={CustomLoadingOverlayTable}
            columnDefs={memoizedColumnDefs}
            rowData={listMatchedCustomers}
            rowHeight={55}
            defaultColDef={{
              resizable: true
            }}
            overlayNoRowsTemplate={NodataTable}

            selectionColumnDef={{
              pinned: 'left',
              lockPosition: 'left',
              suppressMovable: true,
              width: 50,
              minWidth: 50,
              maxWidth: 50,
            }}
            rowSelection={isVoucherLocked ? undefined : rowSelection}
            getRowId={getRowId}
            onGridReady={onGridReady}
            onSelectionChanged={onSelectionChanged}
          />
        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={paginationMatchedCustomers.current}
              pageSize={paginationMatchedCustomers.pageSize}
              total={paginationMatchedCustomers.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(paginationMatchedCustomers.total, paginationMatchedCustomers.pageSize, paginationMatchedCustomers.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationMatchedCustomers}
            />
          </div>
        </ConfigProvider>
      </div>
    </div >
  )
})

export default React.memo(InfoEdit);
